import { useCallback, useEffect, useRef, useState } from 'react'

export function useTurnstile(siteKey, setMessage) {
  const [token, setToken] = useState('')
  const containerRef = useRef(null)
  const widgetRef = useRef(null)

  const reset = useCallback(() => {
    window.turnstile?.reset(widgetRef.current)
    setToken('')
  }, [])

  useEffect(() => {
    if (!siteKey) return undefined
    let cancelled = false
    let pollTimer
    let loadTimer

    const stopPolling = () => {
      window.clearInterval(pollTimer)
      window.clearTimeout(loadTimer)
    }

    const onLoadError = () => {
      stopPolling()
      setMessage('Human verification could not load. Email andrew@evolvea.digital instead.')
    }

    const render = () => {
      if (cancelled || !window.turnstile || !containerRef.current || widgetRef.current != null) return
      try {
        widgetRef.current = window.turnstile.render(containerRef.current, {
          sitekey: siteKey,
          theme: 'dark',
          size: 'flexible',
          appearance: 'interaction-only',
          callback: setToken,
          'expired-callback': () => setToken(''),
          'error-callback': () => setToken(''),
        })
        stopPolling()
      } catch {
        onLoadError()
      }
    }

    let script = document.getElementById('settlementos-turnstile')
    if (!script) {
      script = document.createElement('script')
      script.id = 'settlementos-turnstile'
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
      script.async = true
      script.defer = true
      document.head.append(script)
    }
    script.addEventListener('load', render)
    script.addEventListener('error', onLoadError)
    pollTimer = window.setInterval(render, 200)
    loadTimer = window.setTimeout(onLoadError, 10_000)
    render()

    return () => {
      cancelled = true
      stopPolling()
      script.removeEventListener('load', render)
      script.removeEventListener('error', onLoadError)
      if (widgetRef.current != null) window.turnstile?.remove(widgetRef.current)
      widgetRef.current = null
    }
  }, [siteKey, setMessage])

  return { containerRef, reset, token }
}
